module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('a', {
    attrs: {
      "id": "file_006"
    }
  }), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "file_006"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('strong', [_vm._v("ACKNOWLEDGMENTS")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A book like this cannot be created by a single person. I’d like to thank all of those who helped me with art, translations, suggestions, and information: P. J. Muller, Shauna Simon, Patrick Kam, Shawn Chamberlain, David Brown, Justin Hotard, and Joshua Stoff of the Cradle of Aviation Museum. Those who graciously assisted me in acquiring the images for this volume were Dan Hagedorn, Hill Goodspeed of the National Naval Aviation Museum, Edwin Finney of the Naval Historical Center, and Holly Reed and the helpful people at the National Archives. And thanks to Stan Piet, who years ago collected an amazing assortment of color Hellcat shots, many of which are seen in this book. Great appreciation goes to Larry Feliu and Lynn McDonald of the Grumman Historical Center and the people of Northrop Grumman. Special thanks to Hellcat ace Edward “Wendy” Wendorf and Commemorative Air Force pilot Chris Rushing, who agreed to be interviewed for this volume. Also, thanks to Barbara Feller-Roth and to Steve Gansen and Scott Pearson of Zenith Press, who helped make this book a reality.")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39ee2f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_006.vue
// module id = 69
// module chunks = 0